import http from '@/utils/httpService';
import { rootPath } from '@/utils/globalParam';
import fileExportForGet from '@/utils/fileExportForGet';
import fileExport from '@/utils/fileExport';
// 企业积分明细列表
export const enterprisePointRecordpage = data => http.Axios.post(rootPath + '/api/enterprisePointRecord/page', data)
// /table右侧详情数据
export const enterprisePointInfo = data => http.Axios.post(rootPath + '/api/enterprisePoint/info', data)

//下载接口，最新
export const platformDownload = data => http.Axios.get(rootPath + '/api/platform/upload/download', {
    params: data,
    responseType: 'blob',
    noLoading: true,
})
//单个分配积分
export const enterprisePointDistributeSingle = data => http.Axios.post(rootPath + '/api/enterprisePointRecord/distribute/single', data)
// 积分分配--模板下载
export const distributeDownloadTemplate = data => {
    return fileExportForGet('积分批量分配.xlsx', data, '/api/enterprisePointRecord/distribute/downloadTemplate',)
}
// 积分分配--批量
export const enterprisePointDistributeMultiple=(data)=>http.Axios.post(rootPath+'/api/enterprisePointRecord/distribute/multiple',data, { noLoading: true })
//分配明细列表
export const enterprisePointDistributePage=(data)=>http.Axios.post(rootPath+'/api/enterprisePointRecord/distribute/page',data)

// 分配明细导出
export const enterprisePointDistributeExport=(fileName, data = {}) => {
  fileExport(fileName, data, '/api/enterprisePointRecord/distribute/export');
};

//回收明细列表
export const enterprisePointRetrievePage=(data)=>http.Axios.post(rootPath+'/api/enterprisePointRecord/retrieve/page',data)

//回收明细导出
export const enterprisePointRetrieveExport=(fileName, data = {}) => {
  fileExport(fileName, data, '/api/enterprisePointRecord/retrieve/export');
};
